import { computed } from 'vue';
import { useDevicesStore } from '../devices/device-store';

const getComponentModelFromShortcode = (shortcode) => {
  const store = useDevicesStore();
  const models = computed(() => store.state.models);
  if (!shortcode) return '-';
  const model = models.value.find(a => a.shortcode == shortcode);
  return model ? model.name : '-';
}

export default getComponentModelFromShortcode;
